import { render, staticRenderFns } from "./BreakpointDebug.vue?vue&type=template&id=b6011652"
import script from "./BreakpointDebug.vue?vue&type=script&lang=js"
export * from "./BreakpointDebug.vue?vue&type=script&lang=js"
import style0 from "./BreakpointDebug.vue?vue&type=style&index=0&id=b6011652&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports